import * as React from 'react';
import Project from 'src/entities/Project';
import InvestorType from 'src/entities/InvestorType';
import { RootState } from 'src/reducers/RootReducer';
import { connect, Dispatch } from 'react-redux';
import User from 'src/entities/User';
import { default as InvestmentFormComponent, InvestmentFormComponentProps } from './InvestmentForm.component';
import { openModal, OpenModal } from 'src/actions/modal';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import Investment from 'src/entities/Investment';
import { setInvestmentData, SetInvestmentDataAction } from 'src/actions/investment/set-data/SetInvestmentData.actions';
import {
  indexInvestments,
  IndexInvestmentsAction,
  IndexInvestmentsSuccess
} from 'src/actions/investment/index/IndexInvestments.actions';
import * as indexInvestmentsTypes from '../../../actions/investment/index/Types';
import InvestmentFunnelContainer from './InvestmentFunnel.container';
import ValidatorService from 'src/services/validation/Validation.service';
import Person from 'src/entities/Person';
import ChangeActiveProfileContainer
  from 'src/modules/modals/investment-funnel/change-profile/ChangeActiveProfile.container';
import { history } from 'src/store';

interface StateProps {
  project?: Project;
  user?: User;
  activeProfile?: Person;
  investorType?: InvestorType;
  investment?: Investment;
}

interface DispatchProps {
  openModal(component: JSX.Element, className?: string): void;

  setInvestmentData(investment: Investment): SetInvestmentDataAction;

  indexInvestments(profileId: number, profileType: string, lastYear: boolean, projectId: number):
    Promise<IndexInvestmentsAction>;
}

interface Props extends StateProps, DispatchProps {
  modalRef?: Modal;
  handleBackButton?: () => void;
}

interface State {
  tickets: { name: string; value: string; }[];
  reinvestment?: Investment;
  errorMessage: {};
}

class InvestmentFormContainer extends React.Component<Props, State> {

  public state = {
    tickets: [],
    reinvestment: undefined,
    errorMessage: {}
  };

  public componentWillMount(): void {
    this.props.indexInvestments(
      this.props.activeProfile!.id,
      this.props.activeProfile!.personType,
      false,
      this.props.project!.id
    ).then(
      (response) => {
        if (response.type !== indexInvestmentsTypes.INDEX_INVESTMENT_SUCCESS) {
          return;
        }
        const reinvestment = (response as IndexInvestmentsSuccess).payload[0];
        this.setState({reinvestment: new Investment(reinvestment)});
        if (this.props.investment && this.props.investment.quantityTickets > 0) {
          let investment = this.props.investment;
          investment.quantityTickets = 1;
          this.props.setInvestmentData(new Investment(investment));
        }
      }
    );
    if (!this.props.investment || this.props.investment!.project!.id !== this.props.project!.id) {
      const investment = new Investment({
        quantityTickets: 1,
        tcaRepresentative: false,
        acceptsCommitment: false,
        termsAndConditions: false,
        amountInvested: 0,
        fees: 2,
      });
      if (this.props.user) {
        investment.person = this.props.activeProfile!;
        this.props.setInvestmentData(investment);
      }
      if (this.props.project) {
        investment.project = this.props.project;
        this.props.setInvestmentData(new Investment(investment));
      }
    }
    if (this.props.investorType) {
      this.getTickets();
    }
  }

  public render(): React.ReactNode {
    return (this.props.project && this.props.investorType && this.props.activeProfile &&
      this.props.investment ?
        <InvestmentFormComponent {...this.getComponentProps()} /> : null
    );
  }

  private getTickets(): void {
    let ticketValue = this.props.project!.ticketValue;

    if (this.props.investorType!.type === 'No acreditado' ||
      this.props.investorType!.type === 'Acreditado' &&
      this.props.investorType!.accreditationExpired) {
      let i = 1;
      let tickets = [];
      while (
        i * ticketValue <= 3000 &&
        (this.props.project!.cash + i * ticketValue) <= (this.props.project!.cashTarget * 1.25)
        ) {
        tickets.push({name: i.toString(), value: i.toString()});
        ++i;
      }
      this.setState({tickets: tickets});
    } else {
      let tickets = [];
      for (let i = 1; i <= ((this.props.project!.cashTarget * 1.25 - this.props.project!.cash) / ticketValue); ++i) {
        tickets.push({name: i.toString(), value: i.toString()});
      }
      this.setState({tickets: tickets});
    }
  }

  private changeInvestorProfile(): void {
    this.props.openModal(
      <ChangeActiveProfileContainer/>
    );
  }

  private redirectAcreditation(): void {
    this.props.modalRef!.modal('hide');
    history.push('/mi-cuenta/tipo-de-inversor');
  }

  private handleClick(): void {
    ValidatorService.validate(
      [{value: this.props.investment!.quantityTickets, message: 'emptyInvestment'}]
    ).then(
      () => {
        if (this.state.reinvestment) {
          let investment = new Investment(this.state.reinvestment!);
          investment.quantityTickets += this.props.investment!.quantityTickets;
          investment.tcaRepresentative = investment.tcaRepresentative || this.props.investment!.tcaRepresentative;
          investment.acceptsCommitment = false;
          this.props.setInvestmentData(investment);
          this.props.openModal(<InvestmentFunnelContainer reinvestment={true}/>);
          return;
        }
        this.props.openModal(<InvestmentFunnelContainer reinvestment={false}/>);
      }
    ).catch(
      (errors) => {
        this.setState({errorMessage: errors});
      }
    );
  }

  private handleChange(key: string): (value: string | boolean) => void {
    switch (key) {
      case 'quantityTickets':
        return (
          (value: string) => {
            let quantityTickets = isNaN(parseInt(value, 10)) ? 0 : parseInt(value, 10);
            let newData = {...this.props.investment!, [key]: quantityTickets};
            this.props.setInvestmentData(new Investment(newData));
          }
        );
      default:
        return (
          (value: string | boolean) => {
            let newData = {...this.props.investment!, [key]: value};
            this.props.setInvestmentData(new Investment(newData));
          }
        );
    }
  }

  private getComponentProps(): InvestmentFormComponentProps {
    return {
      investorType: this.props.investorType!,
      person: this.props.activeProfile!,
      project: this.props.project!,
      handleClick: () => this.handleClick(),
      handleChange: (key: string) => this.handleChange(key),
      modalRef: this.props.modalRef!,
      tickets: this.state.tickets,
      investment: this.props.investment!,
      reinvestment: this.state.reinvestment,
      changeInvestorProfile: () => this.changeInvestorProfile(),
      redirectAcreditation: () => this.redirectAcreditation(),
      errorMessage: this.state.errorMessage,
      defaultProfile: this.props.user!.defaultProfile,
      activeProfile: this.props.activeProfile!,
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  openModal: (component: JSX.Element, className?: string): OpenModal => (
    dispatch(openModal(component, className))
  ),
  setInvestmentData: (investment: Investment): SetInvestmentDataAction => (
    dispatch(setInvestmentData(investment))
  ),
  indexInvestments: (
    profileId: number, profileType: string, lastYear: boolean, projectId: number
  ): Promise<IndexInvestmentsAction> => (
    dispatch(indexInvestments(profileId, profileType, lastYear, projectId))
  )
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState):
  StateProps => ({
  project: state.getProject.project,
  user: state.getUser.user,
  activeProfile: state.getUser.activeProfile,
  investorType: state.getInvestorType.investorType,
  investment: state.setInvestmentData.investment,
});

export default connect(mapStateToProps, mapDispatchToProps)(InvestmentFormContainer);



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/InvestmentForm.container.tsx